import DefaultMainPage from "../../pages/DefaultMainPage";
import Country from "./Country";

const countryMenuItems = [
    {path: "/country", component: <Country/>, label: '국가/언어 관리'},
]

export const countryRoutes = {
    path: "/country",
    component: <DefaultMainPage buttons={countryMenuItems}/>,
    children: countryMenuItems
}